import { APIS } from '../constants';
import { useFetchWrapper } from 'helpers';

const usePasswordService = () => {
  const baseUrl = `${process.env.REACT_APP_BASE_API_URL}`;
  const fetchWrapper = useFetchWrapper();

  const forgotPassword = (email: string) => {
    return fetchWrapper.post(new URL(`${baseUrl}${APIS.AUTH.FORGOT_PASSWORD}`), { email });
  };

  const validateResetToken = (token: string) => {
    return fetchWrapper.get(
      new URL(`${baseUrl}${APIS.AUTH.VALIDATE_RESET_TOKEN}?token=${encodeURIComponent(token)}`)
    );
  };

  const resetPassword = (token: string, newPassword: string, confirmPassword: string) => {
    return fetchWrapper.post(new URL(`${baseUrl}${APIS.AUTH.RESET_PASSWORD}`), {
      token,
      newPassword,
      confirmPassword,
    });
  };

  const changePassword = (
    userId: number | null,
    currentPassword: string,
    newPassword: string,
    confirmPassword: string
  ) => {
    return fetchWrapper.post(new URL(`${baseUrl}${APIS.USER.CHANGE_PASSWORD}`), {
      userId,
      currentPassword,
      newPassword,
      confirmPassword,
    });
  };

  return { forgotPassword, validateResetToken, resetPassword, changePassword };
};

export { usePasswordService };
